import React, { useState } from 'react';
import { RadixCreatableSelect } from 'components/common/RadixSelect';
import { Controller, ControllerProps, useFormContext } from 'react-hook-form';
import {
  Error,
  ErrorContainer,
  StyledLabel,
  StyledWrapInput,
} from 'components/theme/Form/Form';
import { uuidv4 } from 'utils';
import { useTranslation } from 'react-i18next';
import { ISelectOptions } from 'features/ShoppingCart/types';

interface ISelectProps extends Partial<ControllerProps> {
  options: ISelectOptions[];
  setOptions: React.Dispatch<React.SetStateAction<ISelectOptions[]>>;
  name: string;
  label?: string;
  onValidate?: (b: string) => boolean;
}

const SelectableInput: React.FC<ISelectProps> = ({
  options,
  setOptions,
  name,
  label,
  onValidate,
  ...props
}) => {
  const { t: translate } = useTranslation();
  const { control } = useFormContext();
  const [inputValue, setInputValue] = useState('');

  const onSetValues = () => {
    const newOption = {
      label: inputValue,
      value: `${uuidv4()}T${inputValue}`,
    };
    setOptions((opts) => [
      ...opts,
      {
        ...newOption,
      },
    ]);
    return newOption;
  };

  return (
    <Controller
      {...props}
      control={control}
      defaultValue={props.defaultValue || ''}
      name={name}
      render={({ field, formState }) => {
        const errorMessage = formState.errors[name]?.message as string;
        return (
          <StyledWrapInput>
            {label && <StyledLabel>{label}</StyledLabel>}
            <RadixCreatableSelect
              className="input-field"
              options={options}
              inputValue={inputValue}
              onChange={field.onChange}
              onInputChange={setInputValue}
              value={field.value}
              formatCreateLabel={(inputValue: string) => `Add "${inputValue}"`}
              onCreateOption={(value: string) => {
                const isValid = onValidate?.(value);
                if (isValid) {
                  const newOption = onSetValues();
                  field.onChange(newOption);
                }
              }}
              placeholder={translate('participantFieldPlaceholder')}
            />
            {errorMessage && (
              <ErrorContainer>
                <Error>{translate(errorMessage)}</Error>
              </ErrorContainer>
            )}
          </StyledWrapInput>
        );
      }}
    />
  );
};

export default SelectableInput;
